<template>
    <section>
        <BlockList :blocks="content.contentBlocks"
                   :enable-container="false"/>

        <div class="bg-white py-35 px-40 my-35">
            <button v-if="showTranslationButton"
                    type="button"
                    class="c-product-details--translate theme-text-linkcolor c-product-details--translate--active mb-20 bg-gray-300 p-10 w-full text-left"
                    @click="translateDescription">
                <CIcon name="g-translate"/>
                <span class="c-product-details--translate-text">{{ labelForTranslateDescription }}</span>
            </button>
            <div v-delegate-html-links
                 v-delegate-on-img-error
                 class="wysiwyg"
                 v-html="bodyText(showTranslated ? translatedContent?.translatedContent || content.standardTermsConditions : content.standardTermsConditions)"/>
            <div v-delegate-html-links
                    v-delegate-on-img-error
                    class="wysiwyg"
                    v-html="content.cultureSpecificTermsConditions"/>
        </div>

        <BlockList :blocks="content.contentBlocksBelow"
                   :enable-container="false"/>

    </section>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue';
import { LegalContentBlockViewModel, TermsAndConditionsViewModel } from '@/types/contentServerContract';
import { LegalContentViewModel } from '@/types/apiServerContract';
import Api from '@/project/http/Api.service';
import serverContext from '@/core/serverContext.service';
import dictionaryService from '@/core/translation/dictionary.service';
import siteService from '@/project/site/site.service';
import tableHtmlService from '@/project/app/blocks/tableHtml.service';

const props = defineProps({
    content: { type: Object as PropType<TermsAndConditionsViewModel>, required: true }
});

const translatedContent = ref<LegalContentViewModel | null>(null);
const showTranslated = ref<boolean>(false);

function bodyText(html: string): string {
    return tableHtmlService.wrapTableInOuterDivs(html);
}

async function translateDescription() {
    if (translatedContent.value === null) {
        const translation = await Api.translate.translateLegalContent(props.content?.pageId, serverContext.siteInfo.languageCode || '');
        translatedContent.value = translation || null;
    }

    showTranslated.value = !showTranslated.value;
}

const showTranslationButton = computed(() => serverContext.siteInfo?.languageCode !== 'en');

const labelForTranslateDescription = computed(():string => {
    const languageTargetString = dictionaryService.languageNameByLanguageCode(siteService.getLanguageCode()?.toLowerCase() || '');
    return showTranslated.value
        ? dictionaryService.get('Product.Details.Translate.ShowOriginal')
        : dictionaryService.get('Product.Details.Translate', [languageTargetString]);
});
</script>
